import React, { Component } from "react";
import { mostRecentFilter, dateSort, lastFilter, firstFilter } from "./helperfunctions";
import { RowOfChildren, TitleRow, newSortIndicators, clearSortIndicators, clickToTableTarget,
   clickToNamedClass, formatRadioId, formatTable, numberToDisplay, setSortIndicator } from "./RenderHelpers";
import SecondServer from "../database/SecondServer";
import { siteAccessCode } from "../database/apiv2SiteAccessor";
import { urlSiteDeviceConfig } from "../database/apiUrls";
import Nosensors from "./Controls/Nosensors";
import ChartModal from "../Chart/ChartModal";
import EZNotify from "../Alert/SimplerNotify";
import FilterPanel from "./Controls/FilterPanel";
import DeviceReadings from "./DeviceReadings";
import { csvDownload } from "../csv/csvExport";
import { siteTZ } from "../database/apiv2SiteAccessor";
import PieStack from "../Chart/PieStack";
import ChartButton from "./Controls/ChartButton";
import CsvButton3 from "./Controls/CsvButton3";
import { consumed, isIgnored } from "./Consumption";
import { fetchSourceDevices } from "../database/fetch";
import { Uncommissioned } from "./Model/Uncommissioned";
import DeviceEdit from "./Controls/DeviceEdit";
import DeviceDecommission from "./Controls/DeviceDecommission";
import TotalUse from "./Controls/TotalUse";
import GridAction from "./Controls/GridAction";
import { cachedPerms, canWrite } from "../Overview/SitePerms"
import { renderLoader } from "../Loading/loading";
import Cookies from "js-cookie";
import { getIcons, nameToIcon } from "./Controls/DeviceIcons";
import { GetOption, GetOptions, } from '../database/Options';
import {lastDay, lastWeek, lastMonth} from './Controls/PeriodDropDown'
import { SiteAncientHistory, computeReading, toUpper } from "./HistoricalData";
import { mediumFormat } from "../timeFunctions/timeFns";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faDatabase, faExclamationCircle} from "@fortawesome/free-solid-svg-icons";
import { getSavedRange } from "./Shared/PersistTime";
import { TryAgain } from "../Alert/CommonNotices";

// available reports
import jsonReportCfg from "./reportcfg";
import "./report.css";
import "../Decorators/Checkmarks.css";
import "../Loading/spinload.css";

export default class MeteringReport extends Component {
  constructor(props) {
    super(props);

    this.reportId = "metering";
    const temp = Cookies.get(this.reportId+"sorder") ?? 
      newSortIndicators(jsonReportCfg.data[this.reportId].displayOrder.length)
    const arrSort = typeof temp === 'string' ? temp.split(",").map(Number) : temp
    this.tableId = "dispTable"; //not changeable at run time
    const savedRange = getSavedRange()
    this.deviceEditMap = [
      { from: "Apt", to: "apt" }, { from: "Building", to: "building" },
      { from: "NodeId", to: "node_id" }, {from: "address", to: "address"}

    ];
    this.siteDeviceConfig = null;
    this.textCols = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    this.state = {
      report: null,
      filterReport: null,
      allData: null,
      formatReport: null,
      config: JSON.parse(JSON.stringify(jsonReportCfg)),
      errorMsg: null,
      endrange: savedRange?.endTime ?? new Date(),
      startrange: savedRange?.startTime ?? new Date(Date.now() - 24 * 3600 * 1000),
      intervalDropDown: this.props.intervalDropDown ?? 0,
      chartProps: null,
      modalShow: false,
      siteView: 0,
      lastSort: Cookies.get(this.reportId+"sort") ?? "",
      colSort: arrSort,
      batteryFormat: 0,
      isLoading: true,
      loader: renderLoader(),
      renderMode: "site",
      deviceId: null,
      deviceModal: false,
      deviceModalId: null,
      graphChannel: 1,
      deviceToEdit: undefined,
      detailChart: true,
      deviceToDecommission: undefined,
      decommissionModal: false,
      deviceStatus: undefined,
    };
    this.deviceStatus = undefined
    this.locationPref = undefined
    this.ss = undefined
    this.startRange = this.startRange.bind(this);
    this.toggleChart = this.toggleChart.bind(this);
    this.siteChart = this.siteChart.bind(this);
    this.sortClick = this.sortClick.bind(this);
    this.setFilters = this.setFilters.bind(this);
    this.decorator = this.decorator.bind(this);
    this.onEdit = this.onEdit.bind(this);
    this.onEditHide = this.onEditHide.bind(this);
    this.onChart = this.onChart.bind(this);
    this.onDetail = this.onDetail.bind(this);
    this.onDecommission = this.onDecommission.bind(this);
    this.onDecommissionHide = this.onDecommissionHide.bind(this)
  }

  async componentDidMount() {
    this.props.breadCrumb([{ display: "Readings", click: undefined }]);
    this.ss = new SecondServer(this.props);
    const site = this.props.getActiveSite()
    const ac = siteAccessCode(site)
    if (site?.site_details?.devices) {
      site.site_details.devices.forEach(i => i.device_id = i.device_id.toUpperCase())
      this.siteDeviceConfig = {data: site?.site_details}
      this.fetchData()
    }
    else {
      const prom = this.ss.apiData(urlSiteDeviceConfig(ac))
      Promise.all([this.props?.data, prom]).then((values) => {
        this.derived(values[0], values[1]) })
    }
    this.fetchIcons(ac)
    this.locationPref = GetOption(await GetOptions (this.props), "locationDesc")?.value
  }

  async componentDidUpdate(prevProps, prevState) {
    if (this.props?.update && prevProps.update < this.props.update) {   // refresh button
      if (this.state.intervalDropDown < 3) { 
        const intervals = [lastDay, lastWeek, lastMonth]
        const range = intervals[this.state.intervalDropDown]()
        this.setState ({startrange:range[0], endrange: range[1]})
      }
      this.fetchData();
    }
    if (prevState.startrange.getTime() !== this.state.startrange.getTime() ||
      prevState.endrange.getTime() !== this.state.endrange.getTime()) {
        this.fetchData();
    }    
    if (prevProps.radioStyle !== this.props.radioStyle) {
      this.setData(this.state.report);
    }
    const site = this.props.getActiveSite()
    this.fetchIcons(siteAccessCode(site))
  }
  componentWillUnmount () {
    Cookies.remove(this.reportId+"sort")
    Cookies.remove(this.reportId+"sorder")
    this.ss.cancel()
  }

  async fetchData() {
    if (!this.state.isLoading) {
      this.setState({ isLoading: true });
    }
    const ac = siteAccessCode(this.props.getActiveSite())
    if (!this.deviceStatus) {
      const pr1 = getIcons ({...this.props, ss: this.ss, ac: ac})
      pr1.then((result) => {this.saveApiIcons(result?.data)})
    }
    const endrange = this.state.endrange;
    const startrange = this.state.startrange;
    const hist = await SiteAncientHistory(this.ss, ac, startrange, endrange);
    toUpper(hist)
    this.derived(hist, this.siteDeviceConfig)
    //console.log (JSON.stringify(jsonResponse))
    this.setErrorMessage(this.ss.getErrorMsg());
    if (this.state.isLoading) {
      this.setState({ isLoading: false });
    }
  }
  async fetchIcons (ac) {
    if (!this.deviceStatus) {
      const prom2 = getIcons ({...this.props, ss: this.ss, ac: ac})
      prom2.then(result => this.saveApiIcons(result?.data))
    }
  }
  targetFilter(hist, config) {
    // removes all devices in hist that are not present in config
    const filter = hist?.data?.data?.raw_data.filter(r => 
      -1 !== config?.data?.devices.findIndex((c) => c.device_id.toUpperCase() === r.DeviceId.toUpperCase())
    )
    return filter
  }
  derived(hist, config) {
    if (hist?.data) 
      this.setState({allData: hist})
    let recent = null
    if (hist?.data && config) {
      if (!this.state.isLoading)
        this.setState({isLoading: true})
      hist.data.data.raw_data = this.targetFilter(hist, config)
      recent = mostRecentFilter(hist.data);
      this.computeReadings ("device_id", config, hist)
      this.consumption (hist.data)
      this.mergeApi("device_id", config, recent)
      this.removeEmptyCols(recent.data.raw_data);
      const site = this.props.getActiveSite();
      this.applyUncommission(recent, site, this.ss);
      recent.data.raw_data = this.removeNonSensors(recent.data.raw_data);
      this.setData(recent)
    }
    return recent
  }
  saveApiIcons (status) {
    this.deviceStatus = status
    if (this.state.report)
      this.setData(this.state.report)
  }
  mergeApiIcons (dispData) {
    const status = this.deviceStatus?.icons
    if (status) {
      dispData.data.raw_data.forEach (i=> 
        i.apiIcon = status.find(s=>s.device_id.toUpperCase() === i.DeviceId.toUpperCase())?.icon)  
    }
  }
  setErrorMessage(latest) {
    if (
      (latest && latest.localeCompare(this.state.errorMsg)) ||
      (latest && this.state.errorMsg)
    )
      this.setState({ errorMsg: latest });
  }
  formatData(serverResponse) {
    if (serverResponse) {
      const displayCopy = serverResponse.data.raw_data.slice(0);
      return this.repeatSort(formatTable(displayCopy, "DeviceId", this.props.radioStyle))
    }
    return serverResponse;
  }
  setData(filteredResponse) {
    if (filteredResponse) {
      this.mergeApiIcons(filteredResponse)
      const formatCopy = this.formatData(filteredResponse);
      const indicator = this.readSortorder()
      this.setState({report: filteredResponse,
        filterReport: filteredResponse.data.raw_data.slice(0),
        formatReport: formatCopy,
        isLoading: false,
        colSort: indicator,
      });
    } 
    else {
      this.setState({ isLoading: false });
    } 
  }

  computeReadings(matchKey, config, target) {
    if (!config?.data) return;
    const sens=[{dest:'ReadVal1', src:'RawReadVal1'},
      {dest:'ReadVal2', src:'RawReadVal2'},
      {dest:'ReadVal3', src:'RawReadVal3'}]
    target.data.data.raw_data.forEach((row) => {
      const index = config.data?.devices.findIndex((s) => s[matchKey] === row.DeviceId);
      if (index > -1 && config?.data?.devices[index]?.sensors.length) {
        const dev = config.data?.devices[index]
        sens.forEach((s, sIndex) => {
          const sens_type = dev?.sensors[sIndex]?.sensor_type
          if (!isIgnored(sens_type) && sens_type !== '01') {
            row[s.dest] = computeReading (dev, row[s.src], sIndex)
          }
        })
      }
      else {
        sens.forEach ((s, sIndex)=> {
          if (row[s.src] !== undefined)
            row['NonComp'+sIndex] = true
        })
      }
    });
  }

  // more rows exist in source than in target.
  mergeApi(matchKey, source, target) {
    if (!source?.data) return;
    source?.data?.devices?.forEach((row) => {
      const ti = target.data.raw_data.findIndex((t) => row[matchKey] === t.DeviceId);
      if (ti === -1) {
        //console.log (row[matchKey]);
        const temp = Object.assign({
          DeviceId: row[matchKey],
          Building: row.building,
          Apt: row.apt,
          address: row.address,
          BattVolt: row.LatestLinkStatusData
            ? (0.001 * parseFloat(row.LatestLinkStatusData.BattVolt)).toFixed(2)
            : "",
          Type: row.type,
          NodeId: row.node_id,
          LinkQuality: row.LatestLinkStatusData
            ? row.LatestLinkStatusData.LinkQuality
            : 0,
          PoweredDownUnits: row.PoweredDownUnits,
          LatestDataPresent: false,
        });
        target.data.raw_data.push(temp);
      } else {
        var dev = target.data.raw_data[ti];
        dev.DeviceId = dev.DeviceId.toString();
        dev.Building = row.building;
        dev.Apt = row.apt;
        dev.address = row.address
        dev.BattVolt = row.LatestLinkStatusData
          ? (0.001 * parseFloat(row.LatestLinkStatusData.BattVolt)).toFixed(2)
          : "";
        dev.Type = row.type;
        dev.NodeId = row.node_id;
        dev.LinkQuality = row.LatestLinkStatusData
          ? row.LatestLinkStatusData.LinkQuality
          : 0;
        dev.PoweredDownUnits = row.PoweredDownUnits;
        dev.LatestDataPresent = row.LatestData;
        if (dev.RawReadVal1 === -1 || dev.ReadVal1 === 4294967295) {
          dev.sortable1 = dev.ReadVal1
          dev.ReadVal1 = "Disconnected";
        }
        else {
          var label = row.sensors[0] ? row.sensors[0].units : "";
          if (label === "Rh%") {
            //dev.ReadVal1 = -2.0468 + 0.0367 * dev.ReadVal1 - 0.0000015955 * Math.pow(dev.ReadVal1,2);
            dev.ReadVal1 = Number(dev.ReadVal1).toFixed(1);
          } else {
            dev.sortable1 = dev.ReadVal1
            dev.ReadVal1 = numberToDisplay(dev.ReadVal1, 3) 
            dev.units1 = label;
          }
        }
        if (dev.RawReadVal2 === -1 || dev.ReadVal2 === 4294967295) {
          dev.sortable2 = dev.ReadVal2
          dev.ReadVal2 = "";
        }
        else {
          label = row.sensors[1] ? row.sensors[1].units : "";
          label = label === "Fahrenheit" ? "°F" : label;
          label = label === "Celcius" ? "°C" : label;
          if (row.sensors.length && !isIgnored(row.sensors[1]?.sensor_type)) {
            dev.sortable2 = dev.ReadVal2
            dev.ReadVal2 = numberToDisplay(dev.ReadVal2, 3);
          }
          dev.units2 = label;
        }
        if (dev?.ReadVal3) {
          dev.sortable3 = dev.ReadVal3
          dev.ReadVal3 = numberToDisplay(dev.ReadVal3, 3)
        }
      }
    });
  }
  consumption(modifiedResponse) {
    // sort readings by date
    const arrWorking = modifiedResponse.data.raw_data;
    const byDate = dateSort(arrWorking, "ReadTime");
    const firsts = firstFilter(byDate, "DeviceId")
    const lasts = lastFilter(byDate, "DeviceId");
    firsts.forEach((dev) => {
      const index = lasts.findIndex((t) => t.DeviceId === dev.DeviceId);
      consumed(dev, lasts[index]);
    });
  }

  startRange(newStart) {
    if (newStart && typeof newStart.getMonth === "function") {
      this.setState({ startrange: newStart });
      return newStart;
    } else return this.state.startrange;
  }

  removeCol(configColumns, configDisplayName, colName) {
    const index = configColumns.findIndex(col => colName === col)
    if (index >= 0) {
      configColumns.splice(index, 1)
      configDisplayName.splice(index, 1)
    }
  }

  removeEmptyCols(arrayData) {
    const reportId = this.reportId;
    let newConfig = this.state.config;
    let colSeq = newConfig.data[reportId].displayOrder;
    let colNames = newConfig.data[reportId].displayName;
    let needSave = false;
    if ((!this.sensorsUsed(arrayData, "SensorType3")) || this.isEmptyCol(arrayData, "ReadVal3", "string")) {
      this.removeCol(colSeq, colNames, "ReadVal3");
      this.removeCol(colSeq, colNames, "units3")
      this.removeCol(colSeq, colNames, "Consumed3");
      this.textCols.splice(9, 3)
      needSave = true;
    }
    if ((!this.sensorsUsed(arrayData, "SensorType2")) || this.isEmptyCol(arrayData, "ReadVal2", "string")) {
      this.removeCol(colSeq, colNames, "ReadVal2");
      this.removeCol(colSeq, colNames, "units2")
      this.removeCol(colSeq, colNames, "Consumed2");
      this.textCols.splice(6,3)
      needSave = true;
    } 
    if (needSave) this.setState({ config: newConfig });
  }
  async applyUncommission(apiJson, site, ss) {
    let arrData = apiJson.data.raw_data;
    const jsonResponse = await fetchSourceDevices(site, ss);
    const arrUncomm = Uncommissioned(jsonResponse);
    arrData.map((device) =>
      arrUncomm.find(
        (u) => (device.uncommissioned = u.device_id === device.DeviceId)
      )
    );
    this.setData(apiJson);
  }
  removeNonSensors(arrData) {
    return arrData.filter((x) => {
      const t = x?.Type ?? "mdt";
      return t.toLowerCase() !== "dcap" && t.toLowerCase() !== "rptr";
    });
  }

  sensorsUsed (arr, col) {
    if (!Array.isArray(arr))
      return true
    const mdt = arr.filter (i=>i.Type !== 'RPTR' && i.Type!== 'DCAP')
    // mdt.forEach(i=>!(i[col] === undefined || isIgnored(i[col] || i[col]==='FF')) ? console.log (col, i[col], i) : ()=>{})
    return !mdt.every(i=>i[col] === undefined || isIgnored(i[col]))
  }
  isEmptyCol(arrWorking, colName, typeWanted) {
    if (!Array.isArray(arrWorking))
      return false
    if (typeWanted === 'string')
      return !arrWorking.some(i=> typeof i[colName] === typeWanted && i[colName])
    return !arrWorking.some (i => typeof i[colName] === typeWanted)
  }
  readSortorder () {
    const temp = Cookies.get(this.reportId+"sorder") ?? this.state.colSort
    return typeof temp === 'string' ? temp.split(",").map(Number) : temp
  }
  //click handler for title row
  sortClick(e) {
    const targ = clickToTableTarget(e)
    if ("id" in targ) {
      let sortInd = this.state.colSort
      let sortedTable = this.state.filterReport.slice(0)
      const column = this.getSortCol(targ.id.trim());
      if (this.state.lastSort === column)
        sortInd = setSortIndicator(targ, this.state.colSort);
      else
        sortInd = setSortIndicator(targ, clearSortIndicators(sortInd));
      const direction = sortInd.find(i=>i>0)
      sortedTable = direction === 1 ? this.sortTableAsc(sortedTable, column) :
          this.sortTableDesc(sortedTable, column)
      const display = formatTable(sortedTable, "DeviceId", this.props.radioFormat());
      this.setState({filterReport: sortedTable, formatReport: display,
        lastSort: column, colSort: sortInd,});
      Cookies.set(this.reportId+'sort', column);
      Cookies.set(this.reportId+'sorder', sortInd)
    }
  }
  getSortCol(colName) {
    const sortmap = {ReadVal1: 'sortable1', ReadVal2: 'sortable2', ReadVal3: 'sortable3'}
    return sortmap[colName] ?? colName
  }
  sortTableAsc (arr, column) {
    return (arr.sort(function (a, b) {
      const x = a[column] ?? ""
      const y = b[column] ?? ""
      if (typeof x === "number") return x - y;
      return x.toString().localeCompare(y);
    }));
  }
  sortTableDesc(arr, column) {
    return (arr.sort(function (a, b) {
      const x = a[column] ?? ""
      const y = b[column] ?? ""
      if (typeof x === "number") return y - x;
      return y.toString().localeCompare(x);
    }));
  }
  // repeat last sort after reloading data
  repeatSort (arr) {
    if (this.state.lastSort) {
      // const temp = this.sortTableAsc(arr, this.state.lastSort)
      const direction = this.state.colSort.find(i=> i>0)
      return direction === 1 ? this.sortTableAsc(arr, this.state.lastSort) :
        this.sortTableDesc(arr, this.state.lastSort)
    }
    return arr
  }

  matchDevice(jsonId, screenDisplay) {
    if (jsonId.startsWith(screenDisplay)) return true;
    const displayString = formatRadioId(jsonId, this.props.radioFormat());
    if (displayString.startsWith(screenDisplay)) return true;
    return false;
  }
  deviceData(deviceId) {
    return this.state.allData.data.data.raw_data.filter((device) => {
      return this.matchDevice(device.DeviceId, deviceId);
    });
  }

  deviceMeta(deviceId) {
    return (
      deviceId &&
      this.state.formatReport.filter((device) => {
        return this.matchDevice(device.DeviceId, deviceId);
      })
    );
  }

  setFilters(which, panelState) {
    if (which === "filter") {
      const search = panelState ?? "";
      this.filter(search);
    }
    if (which === "date") {
      const sd = panelState?.startTime ?? this.state.startrange;
      const ed = panelState?.endTime ?? this.state.endrange;
      const dd = panelState?.dropDown ?? this.state.intervalDropDown;
      this.setState({ startrange: sd, endrange: ed, intervalDropDown: dd });
    }
  }

  filter = (search) => {
    let arrFilter = this.state.report.data.raw_data.slice(0);
    if (search?.length > 0) {
      const lsearch = search.toLowerCase();
      arrFilter = arrFilter.filter((item) =>
        Object.values(item).join().toLowerCase().includes(lsearch)
      );
    }
    const display = formatTable(
      arrFilter,
      "DeviceId",
      this.props.radioFormat()
    );
    this.setState({ filterReport: arrFilter, formatReport: display });
  };
  decorator(props) {
    const device = props.data;
    return nameToIcon(device.apiIcon)
  }
  toggleChart(props) {
    const newstate = !this.state.modalShow;
    this.setState({ modalShow: newstate });
  }
  siteChart(props) {
    const newstate = this.state.siteView ^ 1;
    this.setState({ siteView: newstate });
  }

  showChart() {
    return (<ChartModal show={this.state.modalShow}
        hide={this.toggleChart} chartProps={this.state.chartProps}
        startrange={this.startRange} {...this.props}/>
    );
  }

  renderCSVButton() {
    const csvNote = [
      "From", mediumFormat(this.state.startrange),
      "To", mediumFormat(this.state.endrange),
    ];
    const toCSV = this.state.config.data[this.reportId].toCSV;
    return this.state.modalShow ? null : (
      <CsvButton3 csvClick={csvDownload}
        csvTable={this.tableId} toCSV={toCSV}
        file={this.props.currentSite} annotate={csvNote} />
    );
  }
  onDecommissionHide() {
    this.setState({ decommissionModal: false });
    this.componentDidMount();
  }
  onDecommission(evt) {
    const btn = clickToNamedClass(evt, "actButton");
    this.setState({
      deviceToDecommission: btn.getAttribute("index"),
      decommissionModal: true,
    });
  }
  async onEditHide() {
    this.setState({ deviceToEdit: undefined, editModal: false, 
      colSort: clearSortIndicators(this.state.colSort)});

    const filteredResponse = await this.fetchData();
    this.setData(filteredResponse);
  }
  onEdit(evt) {
    const btn = clickToNamedClass(evt, "actButton");
    //console.log(btn.className, btn.getAttribute("index"));
    this.setState({ deviceToEdit: btn.getAttribute("index"), editModal: true });
  }
  onChart(evt) {
    const btn = clickToNamedClass(evt, "actButton");
    const index = btn.getAttribute("index");
    const table = this.filterUncomm(this.currentTable())
    const deviceId = table[index].DeviceId;
    this.setState({renderMode: "device", deviceId: deviceId,
      graphChannel: 1, detailChart: 1,});
  }
  onDetail(evt) {
    const btn = clickToNamedClass(evt, "actButton");
    const index = btn.getAttribute("index");
    const table = this.filterUncomm(this.currentTable());
    const deviceId = table[index].DeviceId;
    this.setState({
      renderMode: "device",
      deviceId: deviceId,
      graphChannel: 1,
      detailChart: 0,
    });
  }
  canEdit() {
    return canWrite(cachedPerms(this.props.getActiveSite()))
  }
  setReport () {
    const start = this.state.config.data[this.reportId];
    if (this.locationPref === 'address') {
      // replace Building with address
      const index = start.displayName.indexOf("Building")
      if (index > -1) {
        start.displayOrder[index] = "address"
        start.displayName[index] = "Address"
      }
    }
    return start
  }
  cellContent (col, value, key) {
    const errMap = {ReadVal1: 'NonComp0', ReadVal2: 'NonComp1', ReadVal3: 'NonComp2'}
    const errDisp = value[errMap[col]] ? 
      <FontAwesomeIcon icon={faExclamationCircle} key={key} size='xs'color='#E74C3C'/> : null
      return (
      col && col.startsWith("Consumed") && value[col] === '' ?
        <FontAwesomeIcon icon={faDatabase} key={key} color='#F39C12'/> :
        <span key={key}>{value[col] ?? ''}&nbsp;{errDisp} </span>
    )
  }
  renderTable(rawData, tableId) {
    const cfg = this.setReport()
    const colSeq = cfg.displayOrder;
    const colNames = cfg.displayName;
    const sortable = cfg.sortable;
    if (Array.isArray(rawData) && rawData.length > 0) {
      const isDecommissionable = rawData.map((device) =>
        device.type !== "DCAP" ? this.onDecommission : undefined);
      return (
        <table className="csv-table" id={tableId}>
          <thead className="tour-table-head">
            <TitleRow index={0} data={rawData[0]} colName={colNames} colSeq={colSeq}
              graph={this.sortClick} sortable={sortable} colSort={this.state.colSort}/>
          </thead>
          <tbody>
            {rawData.map((dev, index) => (
              <RowOfChildren id={index} key={index}>
                {this.decorator({ data: dev })}
                {this.textCols.map((i) => this.cellContent (colSeq[i], dev, index))}     
                <GridAction id="action" index={index} 
                  onEdit={this.canEdit() ? this.onEdit : null}
                  onChart={this.onChart}
                  onDetail={this.onDetail}
                  onRemove={this.canEdit() ? isDecommissionable[index] : null} 
                  wrap="act-column"/>
              </RowOfChildren>
            ))}
          </tbody>
        </table>
      );
    } else return <Nosensors {...this.props} />;
  }
  currentTable() {
    return this.state.formatReport ? this.state.formatReport : this.state.filterReport;
  }
  filterUncomm(data) {
    if (data?.filter)
      return data?.filter(i=>!i.uncommissioned)
    else
      return data
  }
  showTable() {
    if (this.state.isLoading) return this.state.loader
    const rawData = this.filterUncomm(this.currentTable());
    const tableId = this.tableId; // "dispTable";
    return (
      <div className="table-container">
        {this.state.errorMsg !== null ? <EZNotify message={this.state.errorMsg} styleName="warning" /> 
        : this.state.siteView ? <PieStack {...this.props} report={this.state.filterReport} /> 
        : this.renderTable(rawData, tableId)}
        <br />
      </div>
    );
  }

  matchConfig() {
    const match = this.state.deviceId.toLowerCase();
    const config = this.siteDeviceConfig?.data?.devices;
    return config[config.findIndex((item) => item.device_id.toLowerCase() === match)];
  }
  render() {
    const table = this.filterUncomm(this.currentTable());
    const editData = this.state.deviceToEdit ? table[this.state.deviceToEdit] : undefined;
    const decommissionData = this.state.deviceToDecommission ? table[this.state.deviceToDecommission] : undefined;
    switch (this.state.renderMode) {
      default:
      case "site":
        try {
          const dcapTZ = siteTZ(this.props.getActiveSite());
          //const toCSV = this.state.config.data[this.reportId].toCSV
          return (
            <div className="container-fluid">
              <FilterPanel {...this.props} dropDown={this.state.intervalDropDown}
                propagateState={this.setFilters} startTime={this.state.startrange}
                endTime={this.state.endrange} tz={dcapTZ} > 
                <div className="tour-metering-consumption">
                  <TotalUse data={this.state.formatReport} />
                </div>
                <div className="tour-metering-pageactions">
                  <div>
                    <ChartButton {...this.props} chartClick={this.siteChart} />
                    <span className="btnlabel">Change View</span>
                  </div>
                  {this.renderCSVButton()}
                </div>
              </FilterPanel>
              <DeviceEdit
                {...this.props}
                deviceId={editData?.DeviceId}
                onHide={this.onEditHide}
                show={this.state.editModal}
                objMap={this.deviceEditMap}
                meta={editData}
              />
              <DeviceDecommission
                {...this.props}
                deviceId={decommissionData?.DeviceId}
                onHide={this.onDecommissionHide}
                show={this.state.decommissionModal}
                objMap={this.deviceDecommissionMap}
                meta={decommissionData}
              />
              {this.state.modalShow ? this.showChart() : this.showTable()}
            </div>
          );
        }
        catch (err) {
          console.log (err)
          return (<TryAgain details={"Readings.render mode site: "+err.toString()} />)
        }
      case "device":
        try {
          return (
            <DeviceReadings
              {...this.props}
              deviceId={this.state.deviceId}
              deviceData={this.deviceData(this.state.deviceId)}
              deviceMeta={this.deviceMeta(this.state.deviceId)}
              deviceConfig={this.matchConfig()}
              startTime={this.state.startrange}
              endTime={this.state.endrange}
              intervalDropDown={this.state.intervalDropDown}
              channel={this.state.graphChannel}
              showChart={this.state.detailChart}
            />
          );
        }
        catch (err) {
          console.log (err)
          return (<TryAgain details={"Readings.render mode device: "+err.toString()} />)
        }
    }
  }
}
